import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ProfileManager from '../../services/api/ProfileManager';
import ReduxHooks from '../../store/ReduxHooks';
import { actionCreators } from '../../store/actions';
import useFeedbackHandler from '../../hooks/useFeedbackHandler';
import { OrdersPauseReason } from '../../services/exports/Constants';
import { useSelector } from 'react-redux';
import useSound from '../../hooks/utility/useSound';

export default function OrdersPausedAlertScreen() {
  const { t } = useTranslation(null, { keyPrefix: 'Views:Alerts:OrdersPausedAlertScreen' });

  const { playSound } = useSound();
  const { setFeedback } = useFeedbackHandler({ renderToasts: true });

  const { company } = useSelector((state) => state.company);

  useEffect(() => {
    company?.orders_pause_reason === OrdersPauseReason.Inactivity && playSound();
    const id = setInterval(() => {
      company?.orders_pause_reason === OrdersPauseReason.Inactivity && playSound();
    }, 15000);

    return () => clearInterval(id);
  }, [company?.orders_pause_reason]);

  async function onClick() {
    const { success, data } = await ProfileManager.unpauseOrders();

    if (success) {
      return ReduxHooks.dispatch(actionCreators.company.set(data.data));
    }

    return setFeedback({
      message: t('error_messages.something_went_wrong'),
      type: 'error',
    });
  }

  return (
    <div
      className="z-[1200] h-screen w-screen bg-red-500 fixed inset-0 flex justify-center cursor-pointer p-4"
      onClick={onClick}
    >
      <div className="flex flex-col m-auto">
        <div className="h-80 w-80 rounded-full bg-red-600 m-auto flex">
          <h1 className="m-auto text-white text-[350px]">!</h1>
        </div>
        <h2 className="m-auto text-white mt-8 text-center text-lg font-semibold">{t('header')}</h2>
        <h3 className="m-auto mt-2 text-white text-center text-lg font-normal">{t('text')}</h3>
      </div>
    </div>
  );
}
